{
  "Dashboard": "Pulpit",
  "BlyCareShippingProte": "BlyCare Ochrona przesyłki",
  "LoadingBlyCare": "Ładowanie BlyCare…",
  "LoadingWidgetSetting": "Ładowanie ustawień widżetu…",
  "PreparingYourWorkspa": "Przygotowywanie obszaru roboczego",
  "Language": "Język",
  "English": "English",
  "EnglishDefault": "English (domyślny)",
  "German": "Deutsch",
  "Spanish": "Español",
  "French": "Français",
  "Italian": "Italiano",
  "Japanese": "日本語",
  "Korean": "한국어",
  "Dutch": "Nederlands",
  "Polish": "Polski",
  "Portuguese": "Português",
  "Ukrainian": "Українська",
  "SimplifiedChinese": "简体中文",
  "TraditionalChinese": "繁體中文",
  "SetupGuide": "Przewodnik konfiguracji",
  "CompletedOfTotalComp": "Ukończono {{completed}} z {{total}}",
  "Dismiss": "Zamknij",
  "MoreActions": "Więcej działań",
  "ToggleSetupGuide": "Przełącz przewodnik konfiguracji",
  "ActivateAppEmbed": "Aktywuj osadzenie aplikacji",
  "ClickTheEnableButton": "1. Kliknij przycisk Włącz poniżej, aby otworzyć edytor motywu Shopify.",
  "BlyCareEmbedSection": "2. Znajdź BlyCare w sekcji Osadzenie aplikacji po lewej stronie. Upewnij się, że przełącznik jest włączony. Następnie kliknij Zapisz w prawym górnym rogu.",
  "Enable": "Włącz",
  "PublishWidget": "Opublikuj widżet",
  "PublishStorefront": "Opublikuj widżet w swoim sklepie, aby klienci mogli go kupić.",
  "Publish": "Opublikuj",
  "SetProtectionFee": "Ustaw opłatę za ochronę",
  "FeeYouWantToCharge": "Ustaw opłatę, którą chcesz pobierać od klientów.",
  "Setup": "Skonfiguruj",
  "TestYourWidgetOnYour": "Przetestuj widżet w swoim sklepie",
  "AddAProductToYourCar": "Dodaj produkt do koszyka i sprawdź, czy wyświetla się widżet ochrony przesyłki. Wybierz ochronę przesyłki, przejdź do zamówienia i upewnij się, że produkt z ochroną przesyłki jest uwzględniony na stronie zamówienia.",
  "TestNow": "Przetestuj teraz",
  "Working": "Wszystko działa",
  "NeedHelp": "Potrzebujesz pomocy",
  "MarkAsCompleted": "Oznacz jako ukończone",
  "AppStatus": "Stan aplikacji",
  "AppEmbed": "Osadzenie aplikacji",
  "EnableAppEmbedToDisp": "Włącz osadzenie aplikacji, aby wyświetlać ochronę przesyłki w koszyku.",
  "CartPage": "Wyświetlaj ochronę przesyłki na stronie koszyka.",
  "CheckoutBlock": "Blok zamówienia",
  "CheckoutPage": "Wyświetlaj ochronę przesyłki na stronie zamówienia.",
  "Active": "Aktywny",
  "Inactive": "Nieaktywny",
  "Analytics": "Analityka",
  "Today": "Dzisiaj",
  "Last7Days": "Ostatnie 7 dni",
  "Last30Days": "Ostatnie 30 dni",
  "Last60Days": "Ostatnie 60 dni",
  "Last90Days": "Ostatnie 90 dni",
  "Last365Days": "Ostatnie 365 dni",
  "Custom": "Niestandardowy",
  "Start": "Początek",
  "End": "Koniec",
  "DateRange": "Zakres dat",
  "SelectedRange": "Wybrany zakres: {{range}}",
  "Cancel": "Anuluj",
  "Save": "Zapisz",
  "ChooseAStartDateOnOr": "Wybierz datę początkową nie późniejszą niż data końcowa i nie wybieraj dnia po dzisiejszym.",
  "PreviousMonth": "Poprzedni miesiąc",
  "NextMonth": "Następny miesiąc",
  "ProtectionRevenue": "Przychód z ochrony",
  "ProtectedOrders": "Chronione zamówienia",
  "ProtectedOrderRate": "Odsetek chronionych zamówień",
  "LoadingAnalytics": "Ładowanie analityki…",
  "AnalyticsCouldNotLo": "Nie udało się załadować analityki",
  "RetryAnalytics": "Ponów ładowanie analityki",
  "Resources": "Zasoby",
  "HowDoesShippingProte": "Jak działa ochrona przesyłki?",
  "BlyCareAddsAShipping": "BlyCare dodaje widżet ochrony przesyłki do koszyka. Klienci mogą dodać ochronę do swoich zamówień. Sprzedawca pobiera opłatę za ochronę, decyduje, jakie sytuacje są objęte ochroną, i wykorzystuje te opłaty do rozpatrywania roszczeń.",
  "DoesBlyCareCoverInsu": "Czy BlyCare obejmuje roszczenia ubezpieczeniowe?",
  "NoBlyCareIsNotInsura": "Nie. BlyCare nie jest ubezpieczeniem i nie wypłaca odszkodowań z tytułu roszczeń. BlyCare udostępnia jedynie widżet i narzędzia, za pomocą których sprzedawcy zarządzają własnym programem ochrony przesyłki.",
  "EmailUs": "Napisz do nas",
  "LiveChat": "Czat na żywo",
  "HelpCenter": "Centrum pomocy",
  "Settings": "Ustawienia",
  "CheckoutWidget": "Widżet zamówienia",
  "CartWidget": "Widżet koszyka",
  "PriceSetting": "Ustawienia ceny",
  "ProductSetting": "Ustawienia produktu",
  "AdminLanguage": "Język administratora",
  "AdminLanguageTitle": "Język administratora",
  "AdminLanguageHelp": "Zmienia język aplikacji tylko dla Ciebie. Nie wpływa to na klientów.",
  "AppLanguage": "Język aplikacji",
  "UnableToLoadSettings": "Nie udało się załadować ustawień",
  "TryAgain": "Spróbuj ponownie",
  "Discard": "Odrzuć",
  "LoadingSettings": "Ładowanie ustawień",
  "PageNotFound": "Nie znaleziono strony",
  "ProductSettingsCould": "Nie udało się zapisać ustawień produktu.",
  "Fulfillment": "Realizacja",
  "FulfillmentHelp": "Wybierz, kiedy produkt ochrony jest oznaczany jako zrealizowany.",
  "ManuallyFulfill": "Zrealizuj ręcznie",
  "MarkFulfilledWhenFir": "Oznacz jako zrealizowane, gdy pierwszy produkt w zamówieniu zostanie zrealizowany",
  "MarkFulfilledWhenAll": "Oznacz jako zrealizowane, gdy wszystkie pozostałe produkty w zamówieniu zostaną zrealizowane",
  "MarkFulfilledImmedi": "Oznacz jako zrealizowane natychmiast po utworzeniu zamówienia",
  "Exclusions": "Wykluczenia",
  "ExclusionsHelp": "Wybierz, kiedy ochrona nie powinna mieć zastosowania.",
  "ExclusionType": "Typ wykluczenia",
  "Select": "Wybierz",
  "SelectedExclusions": "Wybrane wykluczenia",
  "RemoveName": "Usuń {{name}}",
  "WhenExcluded": "W przypadku wykluczenia",
  "HideWidget": "Ukryj widżet",
  "KeepWidgetButSkipThe": "Zachowaj widżet, ale pomiń opłatę",
  "ExcludeProductType": "Wyklucz typ produktu",
  "SearchProductType": "Szukaj typu produktu",
  "ExcludeSKU": "Wyklucz SKU",
  "SearchSKU": "Szukaj SKU",
  "ExcludeCollection": "Wyklucz kolekcję",
  "SearchCollection": "Szukaj kolekcji",
  "ExcludeMarket": "Wyklucz rynek",
  "SearchMarket": "Szukaj rynku",
  "ExcludeLanguage": "Wyklucz język",
  "SearchLanguage": "Szukaj języka",
  "Add": "Dodaj",
  "PriceSettingsCouldNo": "Nie udało się zapisać ustawień ceny.",
  "ShippingProtectionPr": "Cena ochrony przesyłki",
  "SetHowMuchPriceDoYou": "Ustaw, jaką kwotę pobierasz od klienta",
  "PricingMethod": "Metoda wyceny",
  "Fixed": "Stała",
  "Percentage": "Procent",
  "UniversalProtectionP": "Uniwersalna cena ochrony",
  "PercentageOfCartSubt": "Procent sumy częściowej koszyka",
  "EditCappedPrice": "Edytuj cenę maksymalną",
  "ShippingProtectionFe": "Opłata za ochronę przesyłki obliczana procentowo od {{minPrice}} USD, rosnąca co {{increment}} USD, ograniczona do {{capped}} USD.",
  "MinProtectionFee": "Minimalna opłata za ochronę",
  "IncrementAmount": "Kwota zwiększenia",
  "CappedProtectionFee": "Maksymalna opłata za ochronę",
  "AddTierPrice": "Dodaj cenę progową",
  "AddTier": "Dodaj próg",
  "TierPriceHelp": "Jeśli cena koszyka nie mieści się w żadnym z ustawionych przedziałów cen progowych, zastosowana zostanie cena uniwersalna ustawiona na poprzedniej stronie.",
  "MinCartPrice": "Minimalna cena koszyka",
  "MaxCartPrice": "Maksymalna cena koszyka",
  "ProtectionFee": "Opłata za ochronę",
  "RemoveTier": "Usuń próg",
  "Required": "Wymagane",
  "ThisFieldIsRequired": "To pole jest wymagane.",
  "MustBeGreaterThanZero": "{{label}} musi być większe niż 0.",
  "MustBeOrLess": "{{label}} musi wynosić {{max}} lub mniej.",
  "AtMostTwoDecimals": "{{label}} może mieć co najwyżej 2 miejsca po przecinku.",
  "MustBeLargerThanMinC": "Musi być większe niż minimalna cena koszyka",
  "MustBeLargerThanMaxC": "Musi być większe niż maksymalna cena koszyka",
  "MustBeSmallerThanMin": "Musi być mniejsze niż minimalna cena koszyka",
  "Price": "Cena",
  "MinimumPrice": "Cena minimalna",
  "Increment": "Zwiększenie",
  "CartPageWidget": "Widżet strony koszyka",
  "CheckoutPageWidget": "Widżet strony zamówienia",
  "WidgetFormat": "Format widżetu",
  "TickerWidget": "Standardowy widżet",
  "CheckoutButtonWidget": "Widżet przycisku zamówienia",
  "Text": "Tekst",
  "MainText": "Tekst główny",
  "Title": "Tytuł",
  "Description": "Opis",
  "MainButtonText": "Tekst głównego przycisku",
  "SecondaryButtonText": "Tekst dodatkowego przycisku",
  "EnabledDescription": "Opis stanu włączonego",
  "DisabledDescription": "Opis stanu wyłączonego",
  "PleaseEnterTitle": "Wprowadź tytuł",
  "PleaseEnterDescript": "Wprowadź opis",
  "PleaseEnterMainButt": "Wprowadź tekst głównego przycisku",
  "PleaseEnterSecondar": "Wprowadź tekst dodatkowego przycisku",
  "PleaseEnterEnabledD": "Wprowadź opis stanu włączonego",
  "PleaseEnterDisabled": "Wprowadź opis stanu wyłączonego",
  "EGViewTerms": "np. Zobacz warunki",
  "EGHttpTerms": "np. https://terms.com",
  "Footer": "Stopka",
  "FooterText": "Tekst stopki",
  "FooterLink": "Link stopki",
  "TooltipLink": "Link podpowiedzi",
  "FooterVisibility": "Widoczność stopki",
  "TitleInfoVisibility": "Widoczność informacji o tytule",
  "Disabled": "Wyłączone",
  "Enabled": "Włączone",
  "Color": "Kolor",
  "ColorStyle": "Styl koloru",
  "SizeAndDisplay": "Rozmiar i wyświetlanie",
  "IconSize": "Rozmiar ikony",
  "IconRadius": "Promień ikony",
  "BorderSize": "Grubość obramowania",
  "BorderRadius": "Promień obramowania",
  "HorizontalPadding": "Dopełnienie poziome",
  "VerticalPadding": "Dopełnienie pionowe",
  "ToggleFormat": "Format przełącznika",
  "Switch": "Przełącznik",
  "Checkbox": "Pole wyboru",
  "Border": "Obramowanie",
  "Background": "Tło",
  "ProtectionDescript": "Opis ochrony",
  "MainButtonBackgrou": "Tło głównego przycisku",
  "EnabledToggle": "Przełącznik włączony",
  "DisabledToggle": "Przełącznik wyłączony",
  "Automatic": "Automatyczny",
  "Neutral": "Neutralny",
  "Info": "Informacja",
  "Success": "Sukces",
  "Warning": "Ostrzeżenie",
  "Critical": "Krytyczny",
  "Subdued": "Przytłumiony",
  "Transparent": "Przezroczysty",
  "ThemeColor": "Kolor motywu",
  "ResetToDefaultColor": "{{label}}: przywróć domyślny kolor",
  "OpenColorPicker": "{{label}}: otwórz wybór koloru",
  "Icon": "Ikona",
  "PackageIcon": "Ikona paczki",
  "PackageIconNumber": "Ikona paczki {{value}}",
  "UploadIcon": "Prześlij ikonę",
  "NoIcon": "Brak ikony",
  "AcceptedFormats": "Akceptowane formaty: PNG, JPG, SVG",
  "MaximumFileSize": "Maksymalny rozmiar pliku: 50 MB",
  "AddFiles": "Dodaj pliki",
  "RemoveImage": "Usuń obraz",
  "Uploading": "Przesyłanie",
  "UploadFailedTryAgain": "Przesyłanie nie powiodło się. Spróbuj ponownie.",
  "ChooseAJPEGPNG": "Wybierz obraz JPEG, PNG lub SVG o rozmiarze do 50 MB.",
  "ChooseNonemptyImage": "Wybierz niepusty obraz JPEG, JPG, PNG lub SVG o rozmiarze do 50 MB.",
  "ImageCouldNotBeRead": "Nie udało się odczytać obrazu.",
  "FileContentsMismatch": "Zawartość pliku musi być zgodna z jego typem obrazu JPEG, PNG lub SVG.",
  "ImageCouldNotBeDecode": "Nie udało się zdekodować obrazu.",
  "InvalidImageUrl": "Usługa przesyłania zwróciła nieprawidłowy adres URL obrazu.",
  "MissingPublicImageUrl": "Usługa przesyłania nie zwróciła publicznego adresu URL obrazu.",
  "CustomCssTooLong": "Niestandardowy CSS może mieć maksymalnie 2000 znaków.",
  "ChooseValidIconUrl": "Wybierz przesłaną ikonę z prawidłowym adresem URL.",
  "EnterNumberRange": "Wprowadź liczbę od {{min}} do {{max}}.",
  "EnterLocaleTextRange": "Wprowadź tekst w języku {{locale}} o długości od 1 do {{limit}} znaków.",
  "EnterValidLearnMoreUrl": "Wprowadź prawidłowy adres URL Więcej informacji rozpoczynający się od https:// lub http://.",
  "ReviewHighlightedFields": "Sprawdź wyróżnione pola.",
  "CannotChangePublishState": "Nie można zmienić stanu publikacji, dopóki formularz nie będzie prawidłowy: {{reason}}",
  "BlyCareCouldNotSave": "BlyCare nie mogło zapisać.",
  "CheckoutRequiresPlus": "Dostosowanie strony zamówienia wymaga Shopify Plus.",
  "SaveSucceededReloadFailed": "Żądanie zapisu powiodło się, ale nie udało się załadować najnowszych ustawień widżetu. Odśwież stronę, aby zweryfikować zmiany.",
  "BlyCareCouldNotComplete": "BlyCare nie mogło ukończyć tego żądania.",
  "ShopifyAuthorizationRequired": "Wymagana jest autoryzacja Shopify.",
  "AppBridgeUnavailable": "Shopify App Bridge jest niedostępny",
  "ExtensionStatusUnavailable": "Stan rozszerzenia Shopify jest niedostępny.",
  "ConfigurationPreview": "Podgląd konfiguracji",
  "On": "Włączone",
  "Off": "Wyłączone",
  "Unpublish": "Cofnij publikację",
  "AppEmbedIsNotEnable": "Osadzenie aplikacji nie jest włączone.",
  "GoEnabled": "Przejdź do włączania",
  "ViewOnYourStorefront": "Zobacz w swoim sklepie",
  "PreviewProtection": "Podejrzyj ochronę",
  "MoreInformation": "Więcej informacji",
  "Cart": "Koszyk",
  "Subtotal": "Suma częściowa",
  "Checkout": "Zamówienie",
  "DiscountCode": "Kod rabatowy",
  "Apply": "Zastosuj",
  "Shipping": "Wysyłka",
  "Total": "Razem",
  "ShippingProtection": "Ochrona przesyłki",
  "Product": "Produkt",
  "CopyLink": "Kopiuj link"
}
